import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';

class Label extends Component {

    state = {
        label: this.props.initialValues.label || 'Label',
    }

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            label: this.state.label,
        };
        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setLabel = (e) => {
        this.setState({ label: e.target.value })
    }

    render() {
        const { textColor, isResultInput } = this.props;
        return (
            <>
                <AppInputWrapper
                    labelFontSize={'18px'}
                    label={this.state.label}
                    color={textColor}
                >
                    <div className="empty-space"/>
                </AppInputWrapper>
                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            <label>
                                <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                label
                            </label>
                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Label);